export const MESSAGE_STATUS = {
  READ: 'Read',
  UN_READ: 'UnRead',
  ARCHIVE: 'ARCHIVE',
} as const;

export const MESSAGE_TYPE = {
  ALL: 'all',
  FILING: 'filing',
  GENERAL: 'general',
} as const;

export const INBOX_TYPE = {
  INBOX: 'inbox',
  ARCHIVE: 'archive',
} as const;
